import { z } from "@brains/utils/zod";

/**
 * Conversation metadata is stored as JSON text in SQLite but flows through
 * the API as a plain object. This schema accepts either shape and falls back
 * to `{}` for anything else (legacy null, parse errors, non-record JSON).
 */
export const conversationMetadataSchema: z.ZodCatch<
  z.ZodPreprocess<z.ZodRecord<z.ZodString, z.ZodUnknown>>
> = z
  .preprocess(
    (value) => {
      if (typeof value !== "string") return value;
      try {
        return JSON.parse(value);
      } catch {
        return undefined;
      }
    },
    z.record(z.string(), z.unknown()),
  )
  .catch({});

export function coerceConversationMetadata(
  value: unknown,
): Record<string, unknown> {
  return conversationMetadataSchema.parse(value);
}
